/**
 * Derive the WebSocket base URL the same way api/client.ts derives the REST
 * baseURL — from window.location.hostname. The previous pattern of reading
 * VITE_WS_URL from .env files is broken in two ways:
 *
 *   1. .env.production was never populated, so prod builds had no value.
 *   2. .env.local (with ws://localhost:3001) leaked into prod builds because
 *      Vite loads .env.local in every mode by default.
 *
 * Result: the Capacitor app baked-in localhost:3001 and tried to connect to
 * the phone's own loopback (no server there), and Android blocked cleartext
 * ws:// on top of that — flooding logcat with ERR_CLEARTEXT_NOT_PERMITTED.
 *
 * Hostname detection mirrors the REST client so the two stay in lockstep:
 *   - host includes 'lotngo.com'  → wss://api.lotngo.com  (prod / Capacitor)
 *   - anything else                → ws://localhost:3001   (dev)
 */
export function getWsBaseUrl(): string {
  if (typeof window === 'undefined') return 'ws://localhost:3001';
  const host = window.location.hostname;
  return host.includes('lotngo.com') ? 'wss://api.lotngo.com' : 'ws://localhost:3001';
}
